import { format as formatDate, parse, isValid } from 'date-fns';
import _get from 'lodash/get';
import _set from 'lodash/set';
import _forEach from 'lodash/forEach';
import _defaultTo from 'lodash/defaultTo';

const YEAR_FORMAT = 'yyyy';
const DATE_FORMAT = 'MMMM d, yyyy';
const TIME_FORMAT = 'h:mm a';

export const getDefaultDateFormat = () => DATE_FORMAT;

export const getUserDateFormat = appContext => {
    const { currentUser, currentEmployer } = appContext;
    return _defaultTo(currentEmployer ? _get(currentEmployer, 'dateFormat') : _get(currentUser, 'dateFormat'), DATE_FORMAT);
};

export const getFormattedYear = (date, format = YEAR_FORMAT) => {
    if (isValid(date)) {
        return formatDate(date, format);
    } else {
        return 'Unknown Date';
    }
};

export const getFormattedDate = (date, format = DATE_FORMAT) => {
    if (isValid(date)) {
        return formatDate(date, format);
    } else {
        return 'Unknown Date';
    }
};

/**
 * Take two Date objects, and combine the date portion of the first object with the time portion of the second object.
 *
 * @param {*} date Date
 * @param {*} time Date
 */
export const getCombinedDateTime = (date, time) => {
    return parse(`${formatDate(date, DATE_FORMAT)} ${formatDate(time, TIME_FORMAT)}`, `${DATE_FORMAT} ${TIME_FORMAT}`, new Date());
};

export const getFormattedTime = (date, format = TIME_FORMAT) => {
    return formatDate(date, format);
};

export const getFormattedMessageDate = (date, userDateFormat = DATE_FORMAT) => {
    return formatDate(date, `eeee, ${userDateFormat}`);
};

export const convertFirebaseTimestampsToDate = (data, timestampFieldNameList) => {
    _forEach(timestampFieldNameList, fieldName => {
        const field = _get(data, fieldName);
        if (field) {
            _set(data, fieldName, field.toDate ? field.toDate() : new Date());
        }
    });
    return data;
};

export const convertMsFieldsToDate = (data, msFieldNameList) => {
    _forEach(msFieldNameList, fieldName => {
        const field = _get(data, fieldName);
        if (field) {
            _set(data, fieldName, new Date(field));
        }
    });
    return data;
};
